import { render, staticRenderFns } from "./official-accounts.vue?vue&type=template&id=75a7bfd6"
import script from "./official-accounts.vue?vue&type=script&lang=js"
export * from "./official-accounts.vue?vue&type=script&lang=js"
import style0 from "./official-accounts.vue?vue&type=style&index=0&id=75a7bfd6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports